import React, {useContext} from "react";
import {AdvancedImage, responsive} from '@cloudinary/react';
import {ProjectsContext} from "../../../../App";
import './style.scss';

const Image = ({src, index, onClick}) => {
    const {cld} = useContext(ProjectsContext);
    const myImage = cld.image(src);

    return (
        <div className='image' onClick={() => onClick && onClick(index, src)}>
            <AdvancedImage cldImg={myImage} plugins={[responsive({steps: 200})]} className='cover'/>
        </div>
    )
}

export default Image;
